import { qs } from "../dom-helpers";

class Header {
  constructor() {
    this.hamburger = qs(".hamburger");
    this.navMenu = qs(".header__nav-wrapper");
    this._run();
  }

  _run() {
    try {
      this._registerEventListeners();
    } catch (e) {
      console.error(e); // eslint-disable-line
    }
  }

  _registerEventListeners() {
    if (this.hamburger) {
      this.hamburger.addEventListener("click", () =>
        this._handleHamburgerMenu()
      );
    }
  }

  _handleHamburgerMenu() {
    this.hamburger.classList.toggle("is-active");
    this.navMenu.classList.toggle("nav-menu--opened");
  }
}

export default Header;
